import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Benefícios', id: 'benefits' },
    { name: 'Sobre', id: 'about' },
    { name: 'Depoimentos', id: 'testimonials' },
    { name: 'Conteúdo', id: 'curriculum' }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setIsOpen(false);
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-[#2c3a50] border-b border-[#c5a059]/20 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="text-4xl select-none filter drop-shadow-md hover:scale-110 transition-transform">
              🌱
            </div>
            <div className="flex flex-col">
              <span className="text-white font-black text-xl leading-none tracking-tighter">SEMENTINHA</span>
              <span className="text-[#c5a059] font-bold text-[8.5px] leading-none tracking-[0.05em] mt-1 uppercase">Desenvolvimento Emocional Saudável</span>
            </div>
          </div>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button 
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-white/80 hover:text-[#c5a059] transition-colors font-semibold text-[10px] uppercase tracking-widest"
              >
                {item.name}
              </button>
            ))}
            <a 
              href="https://pay.kiwify.com.br/IotGhts" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#c5a059] text-white px-8 py-2.5 rounded-full font-bold hover:bg-white hover:text-[#2c3a50] transition-all shadow-[0_4px_15px_rgba(197,160,89,0.3)] text-xs"
            >
              INSCREVER-SE
            </a>
          </nav>

          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-white">
            <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>
      </div>

      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="lg:hidden bg-[#2c3a50] border-b border-[#c5a059]/20 p-4 space-y-4"
        >
          {navItems.map((item) => (
            <button 
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="block w-full text-left text-white font-bold text-lg"
            >
              {item.name}
            </button>
          ))}
          <a href="https://pay.kiwify.com.br/IotGhts" className="block w-full bg-[#c5a059] text-white py-4 rounded-xl font-bold text-center">
            COMEÇAR AGORA
          </a>
        </motion.div>
      )}
    </header>
  );
};

export default Header;